import { POWERED_BY } from './supportConstants';

export const APP_NAME = 'WorkLoop';

export const APP_TAGLINE = 'Seamless Team Communication';

export const APP_DESCRIPTION =
  'WorkLoop is a modern corporate communication platform built for teams that need fast messaging, organized channels, task tracking, and secure collaboration in one place. Stay connected with real-time chat, manage work with built-in tasks, share announcements, and integrate with your existing tools—all from desktop or mobile.';

export const APP_FEATURES = [
  {
    title: 'Real-time Messaging',
    description:
      'Send and receive messages instantly with WebSocket-powered chat. Typing indicators and presence keep your team in sync.',
  },
  {
    title: 'Channels & Direct Messages',
    description:
      'Create public and private channels for projects, or chat one-on-one with teammates in direct messages.',
  },
  {
    title: 'Task Management',
    description:
      'Track tasks alongside conversations. Assign work, monitor progress, and link issues to your workflow.',
  },
  {
    title: 'Announcements',
    description:
      'Broadcast important updates to your organization with dedicated announcement channels.',
  },
  {
    title: 'File Sharing',
    description:
      'Share images, documents, and files directly in conversations without leaving the app.',
  },
  {
    title: 'CUMIN Integration',
    description:
      'Raise and track CUMIN issues from WorkLoop tasks to connect chat with your issue-tracking workflow.',
  },
  {
    title: 'Secure & Private',
    description:
      'JWT authentication, encrypted credentials, and role-based access help keep your workspace data protected.',
  },
  {
    title: 'Dark & Light Mode',
    description:
      'Choose the theme that suits you. WorkLoop adapts to your preference for comfortable day or night use.',
  },
];

export const APP_AUDIENCE =
  'WorkLoop is designed for businesses, startups, and teams that want a Slack-like communication hub tailored to their organization—with admin controls, user verification, and enterprise-friendly policies.';

export { POWERED_BY };
